export function videosSection() {
  let timeout;

  $('.videos').on({
    'mouseenter': function () {
      let
        videoBlock = $(this),
        otherBlocks = videoBlock.siblings();

      timeout = setTimeout(function () {
        otherBlocks.removeClass("active").find('video').each(function () {
          this.pause();
        });

        videoBlock.addClass("active").find('video')[0].play();
      }, 200);
    },

    'mouseleave': function () {
      clearTimeout(timeout);
    }

  }, '.video-block').on('mouseleave', function () {
    clearTimeout(timeout);

    $(this).find('.active').removeClass("active").find('video').each(function () {
      this.pause();
    });
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/videosSection.js